import { useState, useEffect, useRef } from 'react';

interface NetworkStatus {
  isOnline: boolean;
  wasOffline: boolean;
}

export function useNetworkStatus(): NetworkStatus {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [wasOffline, setWasOffline] = useState(false);
  const wasOfflineTimerRef = useRef<ReturnType<typeof setTimeout>>(undefined);

  useEffect(() => {
    const goOffline = () => setIsOnline(false);

    const goOnline = () => {
      setIsOnline(true);
      setWasOffline(true);
      // Clear "back online" indicator after 3 seconds
      wasOfflineTimerRef.current = setTimeout(() => setWasOffline(false), 3000);
    };

    window.addEventListener('online', goOnline);
    window.addEventListener('offline', goOffline);

    return () => {
      window.removeEventListener('online', goOnline);
      window.removeEventListener('offline', goOffline);
      if (wasOfflineTimerRef.current) clearTimeout(wasOfflineTimerRef.current);
    };
  }, []);

  return { isOnline, wasOffline };
}
